import Modal from "../../../modal";
import styles from "../styles.module.css";
import { MdClose } from "react-icons/md";
import { Select, Option } from "../../../select";
import { useState, useEffect } from "react";

export default function Validator({ validate, setValidate, onSave }) {
  const [schema, setSchema] = useState({});
  const getSchema = (data, type, name) => {
    const schema = { type: type, name: name, fields: {}, list: false };
    let _data = data;
    if (Array.isArray(data)) {
      schema.list = true;
      _data = data[0];
    }
    if (typeof _data === "string") {
      schema.type = "Text";
      schema.sample = _data;

      schema.fields = null;
      return schema;
    }
    if (typeof _data === "number") {
      schema.type = "Number";
      schema.fields = null;
      schema.sample = _data;
      return schema;
    }
    if (typeof _data === "object" && _data !== null) {
      Object.keys(_data).forEach((k) => {
        schema.fields[k] = getSchema(_data[k], type + "-" + k, k);
      });
      return schema;
    }

    return schema;
  };

  useEffect(() => {
    if (validate) {
      if (validate.data) {
        if (!validate.data.data.error) {
          const data = validate.data.data.data;
          const schema = getSchema(
            data,
            validate.call.name,
            validate.call.name
          );
          console.log(schema);
          setSchema(schema);
        }
      }
    }
  }, [validate]);

  const updateSchema = (field, type, value) => {
    const _schema = { ...schema };
    let holder = _schema;
    const path = type.split("-");
    path.shift();
    path.forEach((field) => {
      holder = holder.fields[field];
    });
    console.log(holder);
    holder.fields[field].type = value;
    setSchema(_schema);
  };

  if (!validate) {
    return null;
  }
  if (validate.loading) {
    return (
      <Modal onClose={() => setValidate(null)} open>
        <div className={styles.validator}>
          <div className={styles.validatorTtile}>
            {validate.call.name}
            <MdClose onClick={() => setValidate(null)} className="icon" />
          </div>
          <div className={styles.loading}>Loading Sample Request....</div>
        </div>
      </Modal>
    );
  }

  if (validate.err) {
    return (
      <Modal onClose={() => setValidate(null)} open>
        <div className={styles.validator}>
          <div className={styles.validatorTtile}>
            {validate.call.name}
            <MdClose onClick={() => setValidate(null)} className="icon" />
          </div>
          <div className={styles.loading}>Error Loading Sample Request</div>
        </div>
      </Modal>
    );
  }
  return (
    <Modal onClose={() => setValidate(null)} open>
      <div className={styles.validator}>
        <div className={styles.validatorTtile}>
          {validate.call.name}
          <MdClose onClick={() => setValidate(null)} className="icon" />
        </div>
        <div>
          {schema && <Item updateSchema={updateSchema} schema={schema} />}
        </div>
        <div
          style={{
            borderTop: "1px solid var(--main-border-color)",
            padding: 15,
            display: "flex",
            justifyContent: "center",
            marginTop: 10,
          }}
        >
          <button
            onClick={() => onSave(schema, validate.call)}
            className={styles.validateButton}
          >
            Save
          </button>
        </div>
      </div>
    </Modal>
  );
}

const Item = ({ schema, onChangeType, updateSchema }) => {
  return (
    <div style={{ paddingLeft: 15 }}>
      {schema.fields && (
        <>
          <div className={styles.item}>
            <div className={styles.typeText}>{schema.type}</div>
            {schema.list && <div>LIST</div>}
          </div>
          {Object.keys(schema.fields).map((key) => {
            return (
              <Item
                onChangeType={(k, v) => updateSchema(k, schema.type, v)}
                updateSchema={updateSchema}
                schema={schema.fields[key]}
              />
            );
          })}
        </>
      )}
      {!schema.fields && (
        <div className={styles.item}>
          <div style={{ flexBasis: 0, flexGrow: 1 }}>
            <div className={styles.nameText}>{schema.name}</div>
            <div className={styles.sampleText}>{schema.sample}</div>
          </div>
          <Select
            value={schema.type}
            onChange={(v) => onChangeType(schema.name, v)}
            style={{ width: 100 }}
          >
            <Option value={"Text"}>Text</Option>
            <Option value={"Number"}>Number</Option>
            <Option value={"File"}>File</Option>
          </Select>
        </div>
      )}
    </div>
  );
};
